import messages from '../../../../messages';

export const DEFAULTS = {
  title: '',
  description: '',
  button_label: '',
  link: null,
  background_color: 'gray',
};

const Schema = (props) => ({
  title: 'FCMH CTA Section',
  fieldsets: [
    {
      id: 'default',
      title: 'Content',
      fields: [
        'title',
        'description',
        'button_label',
        'link',
        'background_color',
        'full_width',
      ],
    },
  ],
  properties: {
    title: {
      title: props.intl.formatMessage(messages.headerTitle),
      type: 'string',
      default: DEFAULTS.title,
    },
    description: {
      title: props.intl.formatMessage(messages.headerDescription),
      widget: 'textarea',
      default: DEFAULTS.description,
    },
    button_label: {
      title: 'Button Text',
      type: 'string',
      default: DEFAULTS.button_label,
    },
    link: {
      title: 'Button Link',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
    background_color: {
      title: 'Hintergrundfarbe',
      type: 'string',
      widget: 'fcmhColorSelect',
      default: DEFAULTS.background_color,
    },
    full_width: {
      title: props.intl.formatMessage(messages.fullWidth),
      type: 'boolean',
      default: false,
    },
  },
  required: ['title', 'button_label'],
});

export default Schema;
